(function () {
  'use strict';

  var PROMPTED_KEY = 'ma_acct_prompted';

  function alreadyShown() {
    try { return !!localStorage.getItem(PROMPTED_KEY); } catch (e) { return true; }
  }

  function markShown() {
    try { localStorage.setItem(PROMPTED_KEY, '1'); } catch (e) {}
  }

  function openModal() {
    var modal = document.getElementById('ma-acct-modal');
    if (!modal) return;
    modal.removeAttribute('hidden');
    document.body.classList.add('ma-modal-open');
    var closeBtn = document.getElementById('ma-acct-close');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 60);
    markShown();
  }

  function closeModal() {
    var modal = document.getElementById('ma-acct-modal');
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.classList.remove('ma-modal-open');
  }

  function tryShow() {
    if (alreadyShown()) return;
    // Small delay so the cart notification/drawer appears first
    setTimeout(openModal, 750);
  }

  document.addEventListener('DOMContentLoaded', function () {
    // --- Close handlers ---
    var ids = ['ma-acct-backdrop', 'ma-acct-close', 'ma-acct-guest'];
    ids.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    // --- Detect successful add-to-cart ---
    // We use event capture to intercept the form submit before Dawn does,
    // then watch the submit button's class list for the loading→idle transition.
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;

        // Only handle forms inside a <product-form> custom element
        var productFormEl = form.closest ? form.closest('product-form') : null;
        if (!productFormEl) return;

        if (alreadyShown()) return;

        var btn = form.querySelector('[type="submit"]');
        if (!btn) {
          // Fallback: just try after 1.4s
          setTimeout(tryShow, 1400);
          return;
        }

        var startTime = Date.now();
        var settled = false;

        var observer = new MutationObserver(function () {
          if (settled) return;
          var isLoading = btn.classList.contains('loading');
          var elapsed = Date.now() - startTime;

          // Button left loading state after at least 300ms → request completed
          if (!isLoading && elapsed > 300) {
            settled = true;
            observer.disconnect();

            // aria-disabled = true and no .loading means sold-out error path
            // aria-disabled = false (or absent) means success
            var ariaDisabled = btn.getAttribute('aria-disabled');
            if (ariaDisabled !== 'true') {
              tryShow();
            }
          }
        });

        observer.observe(btn, {
          attributes: true,
          attributeFilter: ['class', 'aria-disabled']
        });

        // Safety net: disconnect after 8 seconds regardless
        setTimeout(function () {
          if (!settled) { settled = true; observer.disconnect(); }
        }, 8000);
      },
      true // capture phase
    );
  });
})();
